import {
  RECENT_VIEW_ID,
  IN_TRANSIT_VIEW_ID,
  DELIVERED_VIEW_ID,
  DELIVERY_EXCEPTION_VIEW_ID,
  VOIDED_VIEW_ID,
  REFUND_ASSIST_VIEW_ID,
  PENDING_CUSTOMS_DOCUMENTS_VIEW_ID,
} from '../../../components/shipping-grid/views/view-id-constants';
import { inTransit, delivered, undeliverable } from '../../../filters/options/delivery-status/options';
import { isVoided, id as isVoidedId } from '../../../filters/options/is-voided';
import { isRefund, id as isRefundId } from '../../../filters/options/is-refund';
import { pendingCustomsDocumentsOption as pendingCustomsDocumentsFilter } from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/pending-customs-documents';
import deliveryStatusFilter from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/delivery-status';
import shipDateFilter from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/ship-date';
import { DateService } from '../../../services/date-service';

export const createCustomFilterView = (activeFilterView, appliedFilters) => {
  return {
    gridConfigTypeId: activeFilterView.gridConfigTypeId,
    gridViewId: activeFilterView.gridViewId,
    filterViewId: 'custom',
    appliedFilters,
  };
};

const get14DaysAgo = () => {
  const d = new Date();
  d.setDate(d.getDate() - 14);
  return DateService.getFormattedDate(d);
};

const get30DaysAgo = () => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return DateService.getFormattedDate(d);
};

const statusToDefaultFilterViewMap = {
  [RECENT_VIEW_ID]: {
    filterViewId: 'default',
    appliedFilters: [
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateOnOrAfter',
        criterionArgumentValue: get14DaysAgo(),
      },
      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: false,
        isLocked: true,
      },
    ],
  },
  [IN_TRANSIT_VIEW_ID]: {
    filterViewId: 'default-in-transit',
    appliedFilters: [
      {
        ...deliveryStatusFilter,
        filterById: deliveryStatusFilter.id,
        criterionArgumentValue: inTransit.apiKey,
        isLocked: true,
      },
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateLast30Days',
        criterionArgumentValue: get30DaysAgo(),
      },

      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: false,
        isLocked: true,
      },
    ],
  },
  [DELIVERED_VIEW_ID]: {
    filterViewId: 'default-delivered',
    appliedFilters: [
      {
        ...deliveryStatusFilter,
        filterById: deliveryStatusFilter.id,
        criterionArgumentValue: delivered.apiKey,
        isLocked: true,
      },
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateLast30Days',
        criterionArgumentValue: get30DaysAgo(),
      },
      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: false,
        isLocked: true,
      },
    ],
  },
  [DELIVERY_EXCEPTION_VIEW_ID]: {
    filterViewId: 'default-delivery-exception',
    appliedFilters: [
      {
        ...deliveryStatusFilter,
        filterById: deliveryStatusFilter.id,
        criterionArgumentValue: undeliverable.apiKey,
        isLocked: true,
      },
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateLast30Days',
        criterionArgumentValue: get30DaysAgo(),
      },
      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: false,
        isLocked: true,
      },
    ],
  },
  [VOIDED_VIEW_ID]: {
    filterViewId: 'default-voided',
    appliedFilters: [
      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: true,
        isLocked: true,
      },
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateLast30Days',
        criterionArgumentValue: get30DaysAgo(),
      },
    ],
  },
  [REFUND_ASSIST_VIEW_ID]: {
    filterViewId: 'default-refund-assist',
    appliedFilters: [
      {
        ...isRefund,
        filterValue: 'IsRefund',
        filterById: isRefundId,
        criterionArgumentValue: true,
        isLocked: true,
      },
      {
        ...shipDateFilter,
        filterById: shipDateFilter.id,
        criterionOperatorValue: 'dateLast30Days',
        criterionArgumentValue: get30DaysAgo(),
      },
    ],
  },
  [PENDING_CUSTOMS_DOCUMENTS_VIEW_ID]: {
    filterViewId: 'default-pending-customs-documents',
    appliedFilters: [
      {
        ...pendingCustomsDocumentsFilter,
        filterValue: 'PendingDocuments',
        filterById: pendingCustomsDocumentsFilter.id,
        criterionArgumentValue: true,
        isLocked: true,
      },
      {
        ...isVoided,
        filterValue: 'IsVoid',
        filterById: isVoidedId,
        criterionArgumentValue: false,
        isLocked: true,
      },
    ],
  },
};
export const getDefaultFilterView = (statusViewId) => {
  return statusToDefaultFilterViewMap[statusViewId] ?? statusToDefaultFilterViewMap[RECENT_VIEW_ID];
};

export const updateCustomViewProp = (propName, propValue, customView) => {
  return {
    ...customView,
    [propName]: propValue,
  };
};

export const replaceUpdatedFilterView = (propName, propValue, filterViewId, savedFilterViews) => {
  const index = savedFilterViews.findIndex((view) => view.filterViewId === filterViewId);
  if (index === -1) {
    return [...savedFilterViews];
  }

  const filterView = savedFilterViews.find((view) => view.filterViewId === filterViewId);
  const updatedFilterView = {
    ...filterView,
    [propName]: propValue,
  };
  return [...savedFilterViews.slice(0, index), updatedFilterView, ...savedFilterViews.slice(index + 1)];
};
